export default {
  namespaced: true,
  state: {
    all: [],
    loading: false
  },
  getters: {
    all: (state) => state.all,
    find: (state) => (id) => state.all.find(category => category.id == id),
    loading: (state) => state.loading
  },
  mutations: {
    startLoading(state) {
      state.loading = true
    },
    stopLoading(state) {
      state.loading = false
    },
    setAll(state, categories) {
      state.all = categories.sort((a, b) => {
        // Alphanumeric sort by Name
        const nameA = a.name.toUpperCase(); // ignore upper and lowercase
        const nameB = b.name.toUpperCase(); // ignore upper and lowercase

        if (nameA < nameB) return -1
        if (nameA > nameB) return  1
        return 0;
      })
      state.loading = false
    },
    set(state, category) {
      state.all = state.all.filter((o) => o.id != category.id)
      state.all.push(category)
    }
  },
  actions: {
    fetchAll({ commit }) {
      commit('startLoading')
      return Vue.$http.get('qualification_categories').then(
        (response) => commit('setAll', response.data),
        (response) => commit('stopLoading')
      )
    },
    fetch({ commit }, id) {
      return Vue.$http.get(`qualification_categories/${id}`).then(
        (response) => commit('set', response.data)
      )
    }
  }
}
